import styled from '@emotion/styled';
import { keyframes, css } from 'emotion';

import { getThemeColor, theme } from '@ezugi/ui/theme';

const { typography } = theme;

export const ENTER_TIME = 300;

const fadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

const flexCenter = css`
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  background: ${getThemeColor('primary', 0.7)};
  color: ${getThemeColor('primaryContrast')};
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  text-align: center;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  left: env(safe-area-inset-left);
  right: env(safe-area-inset-right);
  z-index: 9999;
  user-select: none;
  opacity: 1;
  font-family: ${typography.font}, sans-serif;
  font-size: 14px;
  animation: ${fadeIn} ${ENTER_TIME / 1000}s linear 1;
`;

export const Wrapper = styled.div`
  border-radius: 8px;
  background-color: ${getThemeColor('background')};
  box-shadow: 0 24px 36px 0 ${getThemeColor('background', 0.5)};
  padding: 12px 16px;
  min-width: 300px;
`;

export const StyledImage = styled.div`
  display: flex;
  ${flexCenter};
`;

export const StyledTitle = styled.div`
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
`;

export const StyledDescription = styled.div`
  text-align: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: auto;
  margin-top: 24px;

  > button {
    margin: 0 8px;
    flex: 1;
    flex-shrink: 0;
    max-width: 50%;
  }
`;
